/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MasterReserveResponseDto
 */
export interface MasterReserveResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof MasterReserveResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof MasterReserveResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    masterReserveId?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    indemnityMaterialDamage?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    indemnityBusinessInterruption?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    underliningSirGovtProgramsSir?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    reservingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    lossAdjustorCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    legalExpertsCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    consultantsCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    otherFees?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    claimsFeesComments?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    programCessionDeclarationName?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    programCessionPercent?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    captiveSirsAag?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    riSirAag?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    riCessionPercent?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    projectedUltimateLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    recoveryPotential?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    recoveryActual?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    recoveryComments?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    claimId?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    totalFguMarketLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    totalFguMarketLossIndemnityExcCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterReserveResponseDto
     */
    totalIncurredCosts?: string;
}

/**
 * Check if a given object implements the MasterReserveResponseDto interface.
 */
export function instanceOfMasterReserveResponseDto(value: object): value is MasterReserveResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MasterReserveResponseDtoFromJSON(json: any): MasterReserveResponseDto {
    return MasterReserveResponseDtoFromJSONTyped(json, false);
}

export function MasterReserveResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MasterReserveResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'masterReserveId': json['masterReserveId'] == null ? undefined : json['masterReserveId'],
        'indemnityMaterialDamage': json['indemnityMaterialDamage'] == null ? undefined : json['indemnityMaterialDamage'],
        'indemnityBusinessInterruption': json['indemnityBusinessInterruption'] == null ? undefined : json['indemnityBusinessInterruption'],
        'underliningSirGovtProgramsSir': json['underliningSirGovtProgramsSir'] == null ? undefined : json['underliningSirGovtProgramsSir'],
        'reservingComments': json['reservingComments'] == null ? undefined : json['reservingComments'],
        'lossAdjustorCosts': json['lossAdjustorCosts'] == null ? undefined : json['lossAdjustorCosts'],
        'legalExpertsCosts': json['legalExpertsCosts'] == null ? undefined : json['legalExpertsCosts'],
        'consultantsCosts': json['consultantsCosts'] == null ? undefined : json['consultantsCosts'],
        'otherFees': json['otherFees'] == null ? undefined : json['otherFees'],
        'claimsFeesComments': json['claimsFeesComments'] == null ? undefined : json['claimsFeesComments'],
        'programCessionDeclarationName': json['programCessionDeclarationName'] == null ? undefined : json['programCessionDeclarationName'],
        'programCessionPercent': json['programCessionPercent'] == null ? undefined : json['programCessionPercent'],
        'captiveSirsAag': json['captiveSirsAag'] == null ? undefined : json['captiveSirsAag'],
        'riSirAag': json['riSirAag'] == null ? undefined : json['riSirAag'],
        'riCessionPercent': json['riCessionPercent'] == null ? undefined : json['riCessionPercent'],
        'projectedUltimateLoss': json['projectedUltimateLoss'] == null ? undefined : json['projectedUltimateLoss'],
        'recoveryPotential': json['recoveryPotential'] == null ? undefined : json['recoveryPotential'],
        'recoveryActual': json['recoveryActual'] == null ? undefined : json['recoveryActual'],
        'recoveryComments': json['recoveryComments'] == null ? undefined : json['recoveryComments'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'totalFguMarketLoss': json['totalFguMarketLoss'] == null ? undefined : json['totalFguMarketLoss'],
        'totalFguMarketLossIndemnityExcCosts': json['totalFguMarketLossIndemnityExcCosts'] == null ? undefined : json['totalFguMarketLossIndemnityExcCosts'],
        'totalIncurredCosts': json['totalIncurredCosts'] == null ? undefined : json['totalIncurredCosts'],
    };
}

export function MasterReserveResponseDtoToJSON(json: any): MasterReserveResponseDto {
    return MasterReserveResponseDtoToJSONTyped(json, false);
}

export function MasterReserveResponseDtoToJSONTyped(value?: MasterReserveResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'masterReserveId': value['masterReserveId'],
        'indemnityMaterialDamage': value['indemnityMaterialDamage'],
        'indemnityBusinessInterruption': value['indemnityBusinessInterruption'],
        'underliningSirGovtProgramsSir': value['underliningSirGovtProgramsSir'],
        'reservingComments': value['reservingComments'],
        'lossAdjustorCosts': value['lossAdjustorCosts'],
        'legalExpertsCosts': value['legalExpertsCosts'],
        'consultantsCosts': value['consultantsCosts'],
        'otherFees': value['otherFees'],
        'claimsFeesComments': value['claimsFeesComments'],
        'programCessionDeclarationName': value['programCessionDeclarationName'],
        'programCessionPercent': value['programCessionPercent'],
        'captiveSirsAag': value['captiveSirsAag'],
        'riSirAag': value['riSirAag'],
        'riCessionPercent': value['riCessionPercent'],
        'projectedUltimateLoss': value['projectedUltimateLoss'],
        'recoveryPotential': value['recoveryPotential'],
        'recoveryActual': value['recoveryActual'],
        'recoveryComments': value['recoveryComments'],
        'claimId': value['claimId'],
        'totalFguMarketLoss': value['totalFguMarketLoss'],
        'totalFguMarketLossIndemnityExcCosts': value['totalFguMarketLossIndemnityExcCosts'],
        'totalIncurredCosts': value['totalIncurredCosts'],
    };
}

